'use strict';
const angular = require('angular');
const {forEach} = angular;
import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';

const illegalCharKeyMap = {'.': ',', '$': '-', '[': '-', ']': '-', '/': '-'};

export function isKeyValidType(key) {
  if (!isUndefined(key) || key === null || !isString(key) || !isNumber(key) || !isBoolean(key)) return false; // 0 is allowed
}

export function keyIsValid(key) {
  if (!isKeyValidType(key)) return false;
  if (!isString(key)) key = '' + key; // convert to string

  forEach(illegalCharKeyMap, function (v, k) {
    if (key.indexOf(k) > -1) return false;
  });
  return true;
}

/**
 * Sanitizes the input key according to the restrictions on firebase keys at
 * https://www.firebase.com/docs/web/guide/understanding-data.html
 * @param key
 * @param lowercase set output to lowercase
 * @returns {string}
 */
export function sanitizeKey(key, lowercase) {
  if (typeof lowercase === 'undefined') lowercase = false;
  forEach(illegalCharKeyMap, function (v, k) {
    key = key.replace(k, v);
  });
  return lowercase ? key.toLowerCase() : key;
}

export function sanitizeObject(data) {
  if (data === null) {
    return data;
  } else if (isString(data)) {
    return data;
  } else if (isNumber(data)) {
    return data;
  } else if (isBoolean(data)) {
    return data;
  } else if (isDate(data)) {
    return data;
  } else if (data === global.window.Firebase.ServerValue.TIMESTAMP) {
    return data;
  } else if (isArray(data)) {
    let result = {}; // technically, this shouldn't be done. firebase handles arrays transparently
    forEach(data, function (value, idx) {
      if (!isUndefined(value)) {
        result['' + idx] = sanitizeObject(value);
      }
    });
    return result;
  } else if (isObject(data)) {
    let result = {};
    forEach(data, function (value, key) {
      if (key.charAt(0) !== '$' && !isUndefined(value)) {
        result[sanitizeKey(key)] = sanitizeObject(value);
      }
    });
    return result;
  }
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/util-methods/index.js